// ThemeContext.tsx
import React, { createContext, useState, useMemo,  useEffect } from 'react';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {  useSelector } from 'react-redux'


const ThemeContext = createContext()

const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');
  const [primaryColor, setPrimaryColor] = useState('#1976d2');
  const [secondaryColor, setSecondaryColor] = useState('#dc004e');
  const muiTheme = useSelector((state) => state.theme.value.muiTheme)

  useEffect(() => {
    const savedMode = localStorage.getItem('themeMode') ;
    const savedPrimary = localStorage.getItem('primaryColor');
    const savedSecondary = localStorage.getItem('secondaryColor');
    if (savedMode) setMode(savedMode);
    if (savedPrimary) setPrimaryColor(savedPrimary);
    if (savedSecondary) setSecondaryColor(savedSecondary);
  }, []);

  const toggleColorMode = () => {
    setMode((prev) => {
      const newMode = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', newMode);
      return newMode;
    });
  };

  const updatePrimaryColor = (color) => {
    setPrimaryColor(color);
    localStorage.setItem('primaryColor', color);
  };

  const updateSecondaryColor = (color) => {
    setSecondaryColor(color);
    localStorage.setItem('secondaryColor', color);
  };

  const theme = useMemo(() =>{
    const newTheme = {
      ...muiTheme,
      palette: {...muiTheme.palette, 
      mode: mode,
      primary:{...muiTheme.palette.primary, main:primaryColor },
      secondary: {...muiTheme.palette.secondary, main:secondaryColor },
      }
    }

    return createTheme(newTheme)
  },
    [mode, primaryColor, secondaryColor,muiTheme]
  );
  

  return (
    <ThemeContext.Provider
      value={{ mode, toggleColorMode, 
        primaryColor, secondaryColor, 
        setPrimaryColor: updatePrimaryColor, 
        setSecondaryColor: updateSecondaryColor }}
    >
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

export { ThemeProvider, ThemeContext };
